<template>
  <div>
    <a-divider orientation="left">Other apps / Ứng dụng khác</a-divider>
    <a-row type="flex" justify="space-around" align="middle">
      <a-col :span="12" class="test" v-for="item in listApp" :key="item.id">
        <a :href="item.url" :target="item.openNewTab ? '_blank': '_self'">
        <a-row type="flex" align="middle" justify="start">
          <a-col :span="6">
            <img
              :src="item.iconUrl"
              class="mr-3"
              :alt="item.name"
              style="max-height: 20px;"
            />
          </a-col>
          <a-col :span="18">
            <span style="
                display: inline-block;
                width: 93px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;
            ">
              {{ item.name }}
            </span>
          </a-col>
        </a-row>
        </a>
      </a-col>
    </a-row>
<!--    <a-divider orientation="left">Danh sách phiếu</a-divider>-->
  </div>
</template>
<style lang="scss" scoped>
.test {
  padding: 5px;
  &:hover {
    border: 1px solid rgba(235, 235, 235, 1);
    -webkit-box-shadow: 2px 2px 2px 0px rgba(235, 235, 235, 1);
    -moz-box-shadow: 2px 2px 2px 0px rgba(235, 235, 235, 1);
    box-shadow: 2px 2px 2px 0px rgba(235, 235, 235, 1);
  }
}
</style>
<script>
import Query from "./query";

const fakeUrlIcon =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAArCAIAAACmUwxBAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAI/SURBVFhH7Zevj+JAFID7Z4wlwaw7HCu3CabJit1kDY6sIpVkFcGQUZdmVWVtJTgMSddc0nM9V8QlRVaOQFQguBnmXWl7dFqgM/erXyqaKdP3ZfreG0Y7/FW0ujJpdWXyD+qS6MO1P1uW9Mt2PyICQc9Tpbvz8QPSFIIesL+D4L8i1k38eQ9eo5De3E9AoIhYN8B8ZZG52BLpbBcmhMMBCBQR6/r4OF17cWMYkUrsvvB42IeRIvV0y+c3SmB9qghXU7dnfYMhiXx3DAh3q66G3ryy9G+IxHtLW9DNupp2j79KFE7Wk0y/bECXrvDQ3cKDZkk2zjDX3BvRpSADfxHvOxdD1lM950q5UfdpikcdfsuU34OGlEnwbqSqnRGePvHbG3VZ3yXe7LQKnZETlm+VtdiFTmYJ9JlHGuu7P7eJaGne8xFKn251x9EroBtYH15Di9hcRsfRpnUpycY9RUL6dH1xXuSStW+6m7ThSNBlnPmONRFnlCRdRq5K0KNVXX0ksB5PM87Vq0RdRu6zdl+d02ctQjvraxd+WJ5CknUZ2aIp8Sgka3mBKtClFFN5Fe/hyWEfry5of2p0Gbka0rqGObOsmWmkCVCrItXpMqLlJKOcAekT6Kxi1OoySLiYD+9SaXQ3nC/CyqYBqNfl7BN++krSJK7F79K9klZXJv+p7sAOYUQqoT3g8a7UJasxn6+W8aqs9Yl16V8CN3/ok4/wAFulS4k9e/ysD3QF1/PY9oRVUkP3T6LVlUmrK4/D4QflBdyVjATCGQAAAABJRU5ErkJggg==";

export default {
  data() {
    return {
      listApp: [
        { id: 1, name: "Ứng dụng ", iconUrl: fakeUrlIcon },
        { id: 2, name: "Ứng dụng ", iconUrl: fakeUrlIcon },
        { id: 3, name: "Ứng dụng ", iconUrl: fakeUrlIcon },
        { id: 4, name: "Ứng dụng ", iconUrl: fakeUrlIcon },
        { id: 5, name: "Ứng dụng ", iconUrl: fakeUrlIcon },
        { id: 6, name: "Ứng dụng ", iconUrl: fakeUrlIcon },
      ],
      getMyAppInPlatform: [],
    };
  },
  watch: {
    getMyAppInPlatform: function (val) {
      if (val && val.length > 0) {
        this.listApp = val;
      }
    },
  },
  created() {
    // Lấy dữ liệu về
    this.$apollo.addSmartQuery("getMyAppInPlatform", {
      query: Query.getMyAppInPlatform,
    });
  },
};
</script>
